import randomstring from 'randomstring';

export const CLASSTING_REDIRECT_URI = `${window.location.origin}/oauth_callback/classting`;
export const CLASSTING_ACCOUNTS_URL = process.env.CLASSTING_ACCOUNTS_URL;
export const CLASSTING_OIDC_CLIENT_ID = process.env.CLASSTING_OIDC_CLIENT_ID;
export const CLASSTING_URL = process.env.CLASSTING_URL;
export const CT_VIEWER_URL = process.env.CT_VIEWER_URL;
export const CT_STORE_URL = process.env.CT_STORE_URL;
export const MINERVA_API_URL = process.env.MINERVA_API_URL;
export const NATIVE_APP_NAME = process.env.NATIVE_APP_NAME;
export const BILL_API_URL = process.env.BILL_API_URL;
export const PERF_API_URL = process.env.PERF_API_URL;
export const LOG_URL = process.env.LOG_URL;
export const GA_ID = process.env.GA_ID;
export const CLASSTING_AI_INTRO_WEB = process.env.CLASSTING_AI_INTRO_WEB;
export const CLASSTING_FULL_AUTH_URL = [
  `${CLASSTING_ACCOUNTS_URL}/oidc/auth`,
  `?client_id=${CLASSTING_OIDC_CLIENT_ID}`,
  '&response_type=id_token+token',
  '&scope=openid+email+profile',
  `&nonce=${randomstring.generate(10)}`,
  `&redirect_uri=${CLASSTING_REDIRECT_URI}`,
].join('');

export const VERSION = process.env.VERSION;
export const USER_TUTORIAL_KEY = 'learning_user_tutorial';
export const CLASSTING_OPEN_API_URL = process.env.CLASSTING_OPEN_API_URL;
export const CONTENT_REPORTS_CONFIG = process.env.CONTENT_REPORTS_CONFIG;
export const CLASSTING_PAY_WEB = process.env.CLASSTING_PAY_WEB;



// WEBPACK FOOTER //
// ./src/config/index.js